export default "__VITE_ASSET__DPDXWvlc__"